<script>
import forminput from "@/router/views/formcomponet/forminput.vue";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import tlpemailtemplate from "@/models/tlpemailtemplate";
import useVuelidate from "@vuelidate/core";
export default {
  mixins: [Api, Sabit, tlpemailtemplate],
  props: ["Id", "AddEdit"],
  data() {
    return {
      v$: useVuelidate(),
      FormData: null,
      ModalOpen: this.AddEdit ? true : false,
      specialTags: [
        "[[KullaniciAdi]]",
        "[[TalepBaslik]]",
        "[[TalepTakipno]]",
        "[[TalepURL]]",
        "[[TalepTip]]",
        "[[AtananBirim]]",
        "[[Durum]]",
        "[[Oncelik]]",
        "[[AtananPersonel]]", 
        "[[Mesaj]]", 
      ],
    };
  },
  components: {
    forminput,
  },
  watch: {
    Id() {
      this.FormData = this.Id;
    },
  },
  methods: {
    onSubmit() {
      this.v$.$touch();
      if (!this.v$.$invalid) {
        if (this.AddEdit == "Add") {
          this.Post("tlpemailtemplate", this.FormData).then((res) => {
            if (res) {
              this.FormData = this.tlpemailtemplateData;
              this.$emit("TableUpdate");
              this.ModalOpen = false;
            }
          });
        } else {
          this.Update("tlpemailtemplate", this.FormData).then((res) => {
            if (res) {
              this.FormData = this.tlpemailtemplateData;
              this.$emit("TableUpdate");
              this.ModalOpen = false;
            }
          });
        }
      }
    },
    Get() { },
    insertTag(tag) {
      // `ref` ile textarea öğesini al
      const textarea = this.$refs.messageTextarea;

      // İmlecin olduğu yere etiketi ekle
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      this.FormData.Mesaj =
        this.FormData.Mesaj.slice(0, start) +
        tag +
        this.FormData.Mesaj.slice(end);

      // İmleci yeni eklenen etiketin sonuna taşı
      this.$nextTick(() => {
        textarea.setSelectionRange(start + tag.length, start + tag.length);
        textarea.focus();
      });
    },
  },
};
</script>
<template>
  <b-modal v-model="ModalOpen" id="tlpemailtemplate" size="lg" :title="this.AddEdit == 'Edit'
      ? 'Kayıt Düzenle'
      : 'Yeni Kayıt Ekle'
    " title-class="font-18" hide-footer>
    <Form @submit.prevent="onSubmit" v-if="FormData">
      <div class="row">
        <forminput class="col-lg-6" :FormDataType="FormDataType.Kod" :Value="FormData.Kod" :v="v$.FormData.Kod"
          @input="FormData.Kod = $event.target.value" />
        <forminput class="col-lg-6" :FormDataType="FormDataType.Tanim" :Value="FormData.Tanim" :v="v$.FormData.Tanim"
          @input="FormData.Tanim = $event.target.value" />

        <forminput class="col-lg-6" :FormDataType="FormDataType.Baslik" :Value="FormData.Baslik" :v="v$.FormData.Baslik"
          @input="FormData.Baslik = $event.target.value" />

        <b-form-group class="col-lg-12" :label="FormDataType.Mesaj.FieldTitle">
          <textarea class="form-control w-100" v-model="FormData.Mesaj" style="min-height: 250px;"
            ref="messageTextarea"></textarea>

          <template v-if="v$.FormData.Mesaj.$error">
            <div v-for="(error, index) of v$.FormData.Mesaj.$silentErrors" :key="index">
              <div>
                <span v-if="error.$validator == 'required'">{{ $t("ValidationMessage.required") }}</span>
                <span v-else>{{ error.$message }}</span>
              </div>
            </div>
          </template>

          <div class="mt-3">
            <h5>Dinamik Etiketler:</h5>
            <div class="d-flex flex-wrap">
              <button type="button" v-for="tag in specialTags" :key="tag" class="btn btn-primary m-1"
                @click="insertTag(tag)">
                {{ tag }}
              </button>
            </div>
          </div>

        </b-form-group>

      </div>

      <button class="btn btn-primary" type="submit">
        Kaydet
      </button>
    </Form>
  </b-modal>
</template>
